import { formataTelefone, formataCep, formataCnpj } from '../../../../utils';

type State = {
	idGrupoConcessionaria: number;
	razaoSocial: string;
	fantasia: string;
	cnpj: string;
	inscricaoEstadual: string;
	inscricaoMunicipal: string;
	email: string;
	telefone: string;
	celular: string;
	cep: string;
	estado: string;
	cidade: string;
	bairro: string;
	logradouro: string;
	numeroLogradouro: string;
	complementoLogradouro: string;
	responsavel: string;
	indicacao: string;
	tagAtivo: string;
	tagDeferimento: string;
	observacao: string;
	prioridade_minuto: number | null;
};

type Action =
	| { type: 'SET_VALUE'; field: string; payload: string }
	| { type: 'SET_SELECT_OPTION'; field: string; value: string | number }
	| { type: 'REPLACE_STATE'; payload: State };

export const newDealershipFormInitialState: State = {
	idGrupoConcessionaria: 0,
	razaoSocial: '',
	fantasia: '',
	cnpj: '',
	inscricaoEstadual: '',
	inscricaoMunicipal: '',
	email: '',
	telefone: '',
	celular: '',
	cep: '',
	estado: '',
	cidade: '',
	bairro: '',
	logradouro: '',
	numeroLogradouro: '',
	complementoLogradouro: '',
	indicacao: '',
	responsavel: '',
	tagAtivo: '',
	tagDeferimento: '',
	observacao: '',
	prioridade_minuto: null,
};

export const newDealershipFormReducer = (state: State, action: Action) => {
	switch (action.type) {
		case 'SET_VALUE':
			const campo = action.field;
			let valor = '';

			switch (campo) {
				case 'telefone':
				case 'celular':
					valor = formataTelefone(action.payload);
					break;
				case 'cep':
					valor = formataCep(action.payload);
					break;
				case 'cnpj':
					valor = formataCnpj(action.payload);

					break;
				default:
					valor = action.payload;
			}

			return {
				...state,
				[action.field]: valor,
			};
		case 'SET_SELECT_OPTION':
			return {
				...state,
				[action.field]: action.value,
			};
		case 'REPLACE_STATE':
			const documento = action.payload.cnpj;
			let documentoFormatado = documento;
			documentoFormatado = formataCnpj(action.payload.cnpj);

			return {
				...action.payload,
				telefone: formataTelefone(action.payload.telefone),
				celular: formataTelefone(action.payload.telefone),
				cep: formataCep(action.payload.cep),
				cnpj: documentoFormatado,
				prioridade_minuto: action.payload.prioridade_minuto ?? null,
			};
		default:
			return state;
	}
};
